import { Injectable } from '@angular/core';
import { InvestCarouselResponse } from '@app/@shared/model/invest.model';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ActionsService {
  private login = new Subject<any>();
  private close = new Subject<any>();
  private reloadOfferBtn = new Subject<any>();
  private favorites = new Subject<any>();
  private publicationFavorites = new BehaviorSubject<any>({});
  private openMatAccordion = new Subject<any>();
  private validateEmail = new Subject<any>();

  public investCarousel$ = new BehaviorSubject<InvestCarouselResponse>(null);

  constructor() {}

  sentEmailObservable(): Observable<any> {
    return this.validateEmail.asObservable();
  }
  sentEmail(confirmation: any) {
    this.validateEmail.next(confirmation);
  }

  publicationFavsObservable(): Observable<any> {
    return this.publicationFavorites.asObservable();
  }
  reloadProperty(favs: any) {
    this.publicationFavorites.next(favs);
  }

  favoritesObservable(): Observable<any> {
    return this.favorites.asObservable();
  }
  favoritesDone(confirmation: any) {
    this.favorites.next(confirmation);
  }

  loginObservable(): Observable<any> {
    return this.login.asObservable();
  }
  loginDone(confirmation: any) {
    this.login.next(confirmation);
  }

  closeComponentObservable(): Observable<any> {
    return this.close.asObservable();
  }
  closeComponent(confirmation: any) {
    this.close.next(confirmation);
  }

  reloadBtnObservable(): Observable<any> {
    return this.reloadOfferBtn.asObservable();
  }
  reloadBtn(confirmation: any) {
    this.reloadOfferBtn.next(confirmation);
  }

  showDocumentationObservable(): Observable<any> {
    return this.openMatAccordion.asObservable();
  }
  showDocumentation(confirmation: any) {
    this.openMatAccordion.next(confirmation);
  }
}
